/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Templates_Refresh_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Refresh templates" |
*
* @param {Event_Templates_Refresh_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_templates_refresh_aria_label = /** @type {((inputs?: Event_Templates_Refresh_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Templates_Refresh_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actualiser les modeles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorlagen aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna i modelli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить шаблоны")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar plantillas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("刷新模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テンプレートを更新する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेम्प्लेट रीफ़्रेश करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar modelos")
	return /** @type {LocalizedString} */ ("Refresh templates")
});